import { confirmable } from 'react-confirm';
import StackedModal from './stacked_modal';
import { useTranslation } from 'react-i18next';

function ActivateDialog({ show, proceed, title, content, confirmText }) {
  const { t } = useTranslation('common');
  return (
    <StackedModal
      isOpen={show}
      title={title || t('common:status.active')}
      content={content || t('common:confirmation.activate')}
      primaryAction={{
        content: confirmText || t('common:button.confirm'),
        onAction: () => {
          proceed(true);
        },
      }}
      onClose={() => {
        proceed(false);
      }}
    />
  );
}

export default confirmable(ActivateDialog);
